ko.bindingHandlers.codemirror = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var options = viewModel.options || {};
        options.value = ko.unwrap(valueAccessor());
        if($(element).attr('data-bind').indexOf('output') != -1) {
            options.readOnly = true;
        }
        element.editor = CodeMirror.fromTextArea(element, options);
        element.editor.on('change', function(cm) {
            var value = valueAccessor();
            value(cm.getValue());
        });
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        if($(element).attr('data-bind').indexOf('output') != -1) {
            var observedValue = ko.unwrap(valueAccessor());
            if (element.editor) {
                element.editor.setValue(observedValue);
                element.editor.execCommand('goDocEnd');
                element.editor.refresh();
            }
        }
    }
};

var VM = function () {
    var self = this;

    self.working = ko.observable(false);
    self.input = ko.observable('');
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });

    self.indentSizeOptions = ko.observableArray([
        { label: 'Compact', value: 0 },
        { label: 'One space', value: 1 },
        { label: 'Two spaces', value: 2 },
        { label: 'Three spaces', value: 3 },
        { label: 'Four spaces', value: 4 },
        { label: 'Five spaces', value: 5 },
        { label: '1 Tab', value: 'tab' }
    ]);
    self.selectedIndentSize = ko.observable(4);
    self.preserveNewlines = ko.observable(false);
    self.output = ko.computed({
        read: function () {
            if(self.selectedIndentSize() === 0) {
                var beautify = js_beautify(self.input(), { indent_size: 0, indent_char: '', preserve_newlines: self.preserveNewlines() });
                var removeComments = beautify.replace(/((?:^|\s)\/\/(.+?)$)|(\/\*(.*?)\*\/)/gms, '');
                var minify = removeComments.replace(/\r?\n|\r/g, '');
                return minify;
            } else if (self.selectedIndentSize() === 'tab') {
                return js_beautify(self.input(), { indent_size: 1, indent_char: '\t', preserve_newlines: self.preserveNewlines(), brace_style: "expand" });
            }
            return js_beautify(self.input(), { indent_size: self.selectedIndentSize(), indent_char: ' ', preserve_newlines: self.preserveNewlines(), brace_style: "expand" });   
        },
        write: function (value) {},
        owner: self
    });
    
    self.options = {
        lineNumbers: true,
        lineWrapping: true,
        mode: "text/x-csharp",
        extraKeys: {
            "F11": function(cm) {
                cm.setOption("fullScreen", !cm.getOption("fullScreen"));
            },
            "Esc": function(cm) {
                if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
            }
        }
    };
    self.allowSetValue = ko.observable(false);

    self.createFile = function() {
        var outputCM = $('.textarea-output').find('.CodeMirror')[0].CodeMirror.getValue();
        var fileName = "Program";
        var regex = /class ((?:[A-Z][a-zA-Z0-9\._]+)+[a-z0-9_])/gm;

        if(outputCM.match(regex)) {
            var matched = outputCM.match(regex)[0];
            matched = matched.replace('class ', '');
            fileName = matched;
        }

        if(outputCM != "") {
            if (outputCM.trim().length != 0) {
                var blob = new Blob([ "" + outputCM + "" ], {
                    type : "text/plain;charset=utf-8"
                });
                saveAs(blob, fileName + ".cs");
            }
        }
    }

    // Copy to clipboard button
    var copyStacktrace = new ClipboardJS('.cpybutton', {
        text: function (evt) {
            return $(evt).parents('.card-csharp').find('.CodeMirror')[0].CodeMirror.getValue();
        }
    });
    copyStacktrace.on('success', function(evt) {
        evt.clearSelection();
        $(evt.trigger).tooltip('show');
        setTimeout(function () {
            $(evt.trigger).tooltip('hide');
        }, 1000);
    });

    // Copy to clipboard for markdown button
    var mrkdStacktrace = new ClipboardJS('#mrkdbutton', {
        text: function (evt) {
            return '```csharp\n' + $(evt).parents('.card-csharp').find('.CodeMirror')[0].CodeMirror.getValue() + '\n```';
        }
    });
    mrkdStacktrace.on('success', function (e) {
        e.clearSelection();
        $('#mrkdbutton').tooltip('show');
        setTimeout(function () {
            $('#mrkdbutton').tooltip('hide');
        }, 1000);
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
}


$(function () {
    var vm = new VM();
    ko.applyBindings(vm, $("body").get(0));

    $(".btn-fullscreen-mode").on('click', function() {
        var cm = $(this).parents('.card').find('.CodeMirror')[0].CodeMirror;
        cm.setOption("fullScreen", !cm.getOption("fullScreen"));
        if(cm.getOption("fullScreen")) { cm.focus(); }
    });
});